import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/Table';
import AdminActions from './AdminActions';

import { adminsTable as TEXT } from 'locales/en/users';

const AdminsTable = ({ data, ...rest }) => {
  const [activeItem, setActiveItem] = useState(null);
  const toggleActiveItem = (id) => {
    if (activeItem === id) {
      setActiveItem(null);
    } else {
      setActiveItem(id);
    }
  };

  return (
    <>
      <h2 className="mb-5 text-base font-bold text-javelin-gray-dark lg:text-xl">
        {TEXT.header}
      </h2>
      <Table
        titles={[TEXT.id, TEXT.name, TEXT.email, TEXT.created_by, '']}
        hasData={!!data.length}
        gridClassName="grid-admins"
        {...rest}
      >
        {data.map((item, idx) => {
          const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;
          return (
            <Fragment key={item.id}>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark`}
              >
                {item.id}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark underline`}
              >
                {item.first_name} {item.last_name}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark underline`}
              >
                {item.email}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`py-3 px-5 text-xs text-javelin-gray-dark underline`}
              >
                {item.created_by}
              </span>
              <span
                data-index-number={dataIndexNumber}
                className={`relative py-3 pr-5 text-right text-xs text-javelin-gray-dark`}
              >
                <AdminActions
                  onClickOpen={() => toggleActiveItem(item.id)}
                  isOpen={activeItem === item.id}
                  onClose={() => setActiveItem(null)}
                  position={idx <= data.length - 4 ? 'bottom' : 'top'}
                />
              </span>
            </Fragment>
          );
        })}
      </Table>
    </>
  );
};

AdminsTable.propTypes = {
  data: PropTypes.array,
};
AdminsTable.defaultProps = {
  data: [],
};
export default AdminsTable;
